import {
  AH_BORDER,
  AH_INPUT_BORDER,
  AH_TEXT,
  AH_TRACK,
  AH_WHITE,
} from "../Compliance/AuditHub/theme";

/** Shared outlined field chrome for Partner Central text + select inputs. */
export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: AH_WHITE,
    fontSize: "0.875rem",
    minHeight: 40,
    "& fieldset": { borderColor: AH_INPUT_BORDER },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused fieldset": { borderColor: AH_TEXT, borderWidth: "1px" },
  },
  "& .MuiInputBase-input": { fontSize: "0.875rem", color: AH_TEXT },
  "& .MuiInputBase-input::placeholder": { color: "#94a3b8", opacity: 1 },
  "& .MuiSelect-select": {
    fontSize: "0.875rem",
    display: "flex",
    alignItems: "center",
  },
};

/** Select field with muted placeholder when empty. */
export const selectFieldSx = (hasValue) => ({
  ...fieldSx,
  "& .MuiSelect-select": {
    ...fieldSx["& .MuiSelect-select"],
    color: hasValue ? AH_TEXT : "#94a3b8",
  },
});

export const selectMenuPaperSx = {
  borderRadius: "8px",
  border: `1px solid ${AH_BORDER}`,
  boxShadow: "0 8px 24px rgba(17, 24, 39, 0.08)",
  maxHeight: 280,
  overflow: "auto",
};

export const selectMenuProps = {
  PaperProps: { sx: selectMenuPaperSx },
  MenuListProps: { dense: false, sx: { py: 0.5 } },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
};

export const menuItemSx = {
  fontSize: "0.875rem",
  fontWeight: 500,
  color: AH_TEXT,
  minHeight: 36,
  py: 0.75,
  mx: 0.5,
  borderRadius: "6px",
  "&.Mui-selected": {
    backgroundColor: "#fff4eb !important",
    color: AH_TEXT,
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#fff4eb !important",
  },
  "&:hover": {
    backgroundColor: AH_TRACK,
  },
};

export const menuItemPlaceholderSx = {
  ...menuItemSx,
  color: "#94a3b8",
  fontStyle: "normal",
  "&.Mui-selected": {
    backgroundColor: "transparent !important",
    color: "#94a3b8",
  },
};

/**
 * Standard SelectProps for Partner Central dropdowns.
 * @param {{ placeholder?: string, renderValue?: Function }} [options]
 */
export const buildSelectProps = ({ placeholder = "", renderValue } = {}) => ({
  displayEmpty: true,
  renderValue:
    renderValue ||
    ((selected) => {
      if (selected == null || selected === "") return placeholder;
      return selected;
    }),
  MenuProps: selectMenuProps,
  IconComponent: undefined,
});

/** Autocomplete popup — single scroll on the listbox only (paper must not scroll). */
export const autocompleteSlotProps = {
  paper: {
    sx: {
      borderRadius: "8px",
      border: `1px solid ${AH_BORDER}`,
      boxShadow: "0 8px 24px rgba(17, 24, 39, 0.08)",
      mt: 0.5,
      overflow: "hidden",
    },
  },
  listbox: {
    sx: {
      py: 0.5,
      maxHeight: 280,
      overflowY: "auto",
      overflowX: "hidden",
      "& .MuiAutocomplete-option": {
        fontSize: "0.875rem",
        fontWeight: 500,
        color: AH_TEXT,
        minHeight: 36,
        mx: 0.5,
        borderRadius: "6px",
        '&.Mui-focused': { backgroundColor: AH_TRACK },
        '&[aria-selected="true"]': { backgroundColor: "#fff4eb" },
        '&[aria-selected="true"].Mui-focused': { backgroundColor: "#fff4eb" },
      },
    },
  },
};
